import { createTheme } from "@mui/material/styles";

const white = "#fff";
const grey = "#757575";
const primaryDefault = "#30B81F";
const secondaryDefault = "#0E67BA";

export default class Theme {

  static get(primaryColor, secondaryColor) {
    const primary = primaryColor || primaryDefault;
    const secondary = secondaryColor || secondaryDefault;

    const selectOverrides = () => ({
      icon: {
        color: "rgba(0,0,0,1)",
        right: 16,
      },
      iconFilled: {
        right: 16,
      },
    });

    const theme = createTheme({
      palette: {
        primary: {
          main: primary,
          contrastText: white,
        },
        secondary: {
          main: secondary,
          contrastText: white,
        },
      },
      typography: {
        fontFamily: "\"museo-sans\", \"Helvetica\", \"Arial\", sans-serif",
        body1: {
          fontSize: "1rem",
          lineHeight: 1.5,
        },
        body2: {
          fontSize: "0.875rem",
          lineHeight: 1.43,
        },
      },
      breakpoints: {
        values: {
          xs: 0,
          sm: 576,
          md: 768,
          lg: 992,
          xl: 1200,
        },
      },
      components: {
        MuiButton: {
          styleOverrides: {
            root: {
              "&:focus-visible": {
                outline: "none",
              },
            },
            outlinedSizeLarge: {
              padding: "7px 21px",
              fontSize: "0.9375rem",
            },
            containedSizeLarge: {
              padding: "8px 22px",
              fontSize: "0.9375rem",
            },
            containedPrimary: {
              "&:focus-visible": {
                boxShadow: `0 0 5px 0px ${primary}`,
                outline: "none",
              },
            },
            containedSecondary: {
              "&:focus-visible": {
                outline: "none",
              },
            },
            outlined: {
              borderWidth: "2px",
              "&:focus-visible": {
                boxShadow: `0 0 5px 0px ${primary}`,
                outline: "none",
              },
            },
            outlinedPrimary: {
              borderWidth: "2px",
              "&:hover": {
                color: primary,
                borderWidth: "2px",
              },
              "&:focus-visible": {
                boxShadow: `0 0 5px 0px ${primary}`,
                outline: "none",
              },
            },
            outlinedSecondary: {
              borderWidth: "2px",
              "&:hover": {
                color: white,
                borderWidth: "2px",
              },
              "&:focus-visible": {
                boxShadow: `0 0 5px 0px ${secondary}`,
                outline: "none",
              },
            },
            text: {
              padding: 0,
              textTransform: "none",
              "&:focus-visible": {
                outline: "none",
              },
            },
            textPrimary: {
              "&:focus-visible": {
                boxShadow: `0 0 5px 0px ${primary}`,
                outline: "none",
              },
            },
            textSecondary: {
              color: `${secondary} !important`,
            },
          },
        },
        MuiIconButton: {
          styleOverrides: {
            root: {
              padding: "8px",
              "&:hover": {
                backgroundColor: "rgba(0, 0, 0, 0.04)",
              },
            },
            sizeSmall: {
              padding: "3px",
            },
          },
        },
        MuiTextField: {
          styleOverrides: {
            root: {
              backgroundColor: white,
              borderRadius: "4px",
            },
          },
        },
        MuiOutlinedInput: {
          styleOverrides: {
            notchedOutline: {
              borderColor: grey,
            },
          },
        },
        MuiFilledInput: {
          styleOverrides: {
            root: {
              backgroundColor: "rgba(0, 0, 0, 0.09)",
            },
          },
        },
        MuiSlider: {
          styleOverrides: {
            root: {
              height: "2px",
            },
            thumb: {
              marginTop: 0,
              height: '12px !important',
              width: '12px !important',
            },
          },
        },
        MuiFormLabel: {
          styleOverrides: {
            root: {
              color: "rgba(0, 0, 0, 0.54)",
              '&.Mui-error': {
                color: '#f44336',
                fontSize: '17px',
              },
            },
          }
        },
        MuiFormHelperText: {
          styleOverrides: {
            root: {
              '&.Mui-error': {
                color: '#f44336',
                fontSize: '13px',
              },
            },
          }
        },
        MuiSelect: {
          styleOverrides: selectOverrides(),
        },
        MuiNativeSelect: {
          styleOverrides: selectOverrides(),
        },
        MuiDialog: {
          defaultProps: {
            disableRestoreFocus: true,
          },
        },
        MuiModal: {
          defaultProps: {
            disableRestoreFocus: true,
          },
        },
      },
    });
    return theme;
  }
}
